interface CalendarProps {
	className?: string;
}

const Calendar = ({ className }: CalendarProps) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M13.3333 2.5V5.83333M6.66659 2.5V5.83333M3.33325 9.16667H16.6666M9.16659 12.5H9.99992V15M4.99992 4.16667H14.9999C15.9204 4.16667 16.6666 4.91286 16.6666 5.83333V15.8333C16.6666 16.7538 15.9204 17.5 14.9999 17.5H4.99992C4.07944 17.5 3.33325 16.7538 3.33325 15.8333V5.83333C3.33325 4.91286 4.07944 4.16667 4.99992 4.16667Z"
			stroke="#5B5B5B"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default Calendar;
